<script>
    import _                         from 'lodash'
    import validate                  from 'validate.js'
    import { createEventDispatcher } from 'svelte'
    import Affected                  from '../../shared/Affected.svelte'
    import Item                      from '../../shared/Item.svelte'
    import * as api                  from '../../shared/api.js'
    import ProfileForm               from './ProfileForm.svelte'
    import Questions                 from './Questions.svelte'
    import Simulation                from './Simulation.svelte'
    
    export let domain
    export let active
    export let item
    export let disabled = false

    let working  = false
    let error    = false
    let affected = []      //activities affected by this profile if removed

    const dispatch = createEventDispatcher()

    const constraints = {
        name : { presence: { allowEmpty: false, message: "campo obrigatório" } },
    }

    function issuesGiven(profile) {
        return profile.issues
    }

    function actionsGiven(item) {
        if(item.id === 0) {
            return []
        }

        const issues = issuesGiven(item)
        return [{
            id              : 'questions',
            name            : `${item.constraints.length} Perguntas`, 
            issues          : issues,
            triggerLoading  : true ,
            onClick         : () => { 
                return Promise.resolve([]) 
            }
        }, {
            id              : 'inquiries',
            name            : 'Simular Pedido', 
            triggerLoading  : true ,
            onClick         : () => { 
                return Promise.resolve([]) 
            }
        }]        
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }
    
    function idOf(item) {
        return item.id
    }
    
    function validateItem(it) {
        return validate(it, constraints, { fullMessages: false }) || {}
    }

    function onUpdate(it) {
        working = true
        return api
            .post("/profile", { domain: domain.id, ...it })
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                error   = false
                dispatch('message', {
                    add     : it.id === 0,
                    payload : json 
                })
                return true
            })
            .catch(err => {
                working = false
                error   = true
                console.log(err)
                return Promise.reject(`Erro ao ${it.id === 0 ? 'adicionar' : 'atualizar'}`)
            })
    }

    function forceRemove() {
        onRemove(item, true)
        affected  = []
    }

    function cancelRemove() {
        affected  = []
    }

    function onRemove(it, force) {
        if(force) alert("NOT IMPLEMENTED")
        working  = true
        error    = false
        affected = []
        return api
            .del(`/profile/${it.id}`)
            .then(res => {
                working = false
                if(res.status === 200) {
                    error = false
                    dispatch('message', { remove: it.id })
                    return true                    
                } else if (res.status === 406) {
                    error = true
                    res.json().then(json => affected  = json)
                } else {
                    error = true
                    return Promise.reject(`Erro ao remover`)
                }
            })
            .catch(err => {
                working = false
                error   = true
                console.log(err)
                return Promise.reject(`Erro ao remover`)
            })
    }

    $: actions = actionsGiven(item)

</script>

<Item
    debug={false} 
    bind:item 
    bind:active 
    {actions}
    {validateItem}
    {idOf}
    {isDirty} 
    disabled={disabled || working}
    {onUpdate}
    {onRemove}>
    <span slot="header">
        {#if item.id > 0}
            <span class="name">{item.name}</span>
            {#if item.description}
                <span class="description">{item.description}</span>
            {/if}
        {/if}
    </span>
    <div slot="primary" let:errors>
        <ProfileForm bind:item {errors}></ProfileForm>
    </div>    
    <div slot="secondary" let:action={action}>
        {#if action && "questions" === action.id}
            <Questions {domain} bind:item></Questions>
        {:else if action && "inquiries" === action.id}
            <Simulation {domain} bind:item></Simulation>
        {:else}
            WTF
        {/if}
    </div>
</Item>

<Affected activities={affected} what="perfil" cancel={cancelRemove} confirm={forceRemove}></Affected>

